"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var emptyFunction = function () {
    // Do nothings
};
var returnEmptyFunction = function () { return emptyFunction; };
/**
 * Latch.
 */
var Latch = /** @class */ (function () {
    function Latch() {
        this.isFirstRun = true;
        this.isFinished = false;
        this.list = [];
    }
    /**
     * Takes a lock, causing execution to wait if number of callers exceeds maxCount.
     *
     * @returns Promise resolved or not depending on if caller must wait.
     */
    Latch.prototype.aquire = function () {
        if (this.isFinished) {
            return Promise.resolve(returnEmptyFunction);
        }
        else if (this.isFirstRun) {
            this.isFirstRun = false;
            return Promise.resolve().then(this.getFirstReleaseFunction.bind(this));
        }
        else {
            return new Promise(this.addResolveToList.bind(this)).then(returnEmptyFunction);
        }
    };
    /**
     * Add promise resolve to list.
     *
     * @param resolve Argument from Promise constructor.
     */
    Latch.prototype.addResolveToList = function (resolve) {
        this.list.push(resolve);
    };
    /**
     * @returns A function for release.
     */
    Latch.prototype.getFirstReleaseFunction = function () {
        var _this = this;
        return function () { return _this.firstRelease(); };
    };
    /**
     * First release.
     */
    Latch.prototype.firstRelease = function () {
        this.isFinished = true;
        this.releaseAll();
    };
    /**
     * Release all promises.
     */
    Latch.prototype.releaseAll = function () {
        this.list.forEach(function (fun) { return fun(); });
        this.list = [];
    };
    return Latch;
}());
exports.default = Latch;
//# sourceMappingURL=Latch.js.map